<template>
<div class="row justify-content-md-center">

	<div class="col-2 d-none d-lg-block">

		<b-jumbotron class="p-4 h-100"
		             v-if="!isFetching.auction">

			<partial-loader :loading="isFetching.previousItem"></partial-loader>

			<div v-if="!isFetching.previousItem && previousItem">

				<b-btn variant="outline-primary"
				       class="w-100 mb-4"
				       v-bind:disabled="isFetching.item"
				       size="lg"
				       v-if="item.previous_auction_order_number"
				       @click="setPage(item.previous_auction_order_number)"
				       v-b-tooltip.hover
				       :title="$t('item.previousItem')">

					<fa-icon icon="spinner"
					         fixed-width
					         spin
					         v-if="isFetching.item" />
					<span v-else>{{ $t('item.previous') }}</span>
				</b-btn>

				<h5>{{ $t('item.auctionOrderNumber') }} {{ item.previous_auction_order_number }}</h5>

				<p>
					<strong>{{ previousItem.seller.code }}-{{ previousItem.number }}</strong> {{ previousItem.title }}
				</p>

				<div v-if="previousItem.media && previousItem.media.length"
				     class="thumbnail"
				     v-bind:style="{ backgroundImage: `url(${previousItem.media[0].url})` }"></div>
			</div>

			<h5 class="text-center"
			    v-if="!isFetching.item && !isFetching.previousItem && previousItem == false">
				{{ $t('item.noPreviousItem') }}
			</h5>
		</b-jumbotron>
	</div>

	<div class="col-md-12 col-lg-8">

		<partial-loader :loading="isFetching.auction"></partial-loader>

		<b-alert v-if="error"
		         show
		         variant="warning">
			{{ error }}
		</b-alert>

		<div v-show="!isFetching.auction">
			<b-jumbotron class="p-4">
				<div class="row">
					<div class="col-lg-12">
						<b-btn :to="{ name: 'auction' }"
						       class="pull-right"
						       variant="outline-secondary"
						       v-b-tooltip.hover
						       :title="$t('auction.stopLive')">
							<fa-icon icon="reply"
							         fixed-width />
						</b-btn>
						<h1 class="display-4"><fa-icon fixed-width icon="gavel" /> {{ auction.title }}</h1>
					</div>

					<div class="col">
						<div class="row">
							<div class="col-md-8">
								<auction-category :selected="item.category"
								                  :internal-search="true"
								                  :deletable="false"
								                  :label="$t('common.category')"
								                  @update:category="changeCategory"></auction-category>
							</div>

							<div class="col-md-4">
								<b-form @submit.prevent="goTo">
									<div class="row">
										<div class="col-sm-8">
											<b-form-group :label="$t('item.gotoAuctionOrderNumber')">
												<b-form-input v-model="goToNumber"
												              type="number"
															  autocomplete="off"
												              :placeholder="$t('item.auctionOrderNumber')"
												              step="1"></b-form-input>
											</b-form-group>
										</div>
										<div class="col-sm-4">
											<b-form-group>
												<b-btn variant="primary"
												       v-bind:disabled="goToNumber == ''"
												       type="submit"
												       block
												       v-b-tooltip.hover
												       :title="$t('item.gotoAuctionOrderNumber')">
													<fa-icon icon="arrow-right"
													         fixed-width
													         v-show="!isGoingTo" />
													<fa-icon icon="spinner"
													         fixed-width
													         spin
													         v-show="isGoingTo" />
												</b-btn>
											</b-form-group>
										</div>
									</div>


								</b-form>
							</div>
						</div>
					</div>
				</div>
			</b-jumbotron>

			<div class="row">
				<div class="col">
					<b-jumbotron class="p-4 h-100">

						<partial-loader :loading="isFetching.item"></partial-loader>

						<div v-if="!isFetching.item && item">
							<div class="row mb-4">
								<div class="col-4"
								     v-if="item.media && item.media.length">
									<div v-if="item.media && item.media.length"
									     class="thumbnail"
									     v-bind:style="{ backgroundImage: `url(${item.media[0].url})` }"></div>
								</div>

								<div class="col">

									<b-button-group class="pull-right"
									                size="sm">
										<b-btn variant="outline-primary"
										       v-b-tooltip.hover
										       :title="$t('common.seller')"
										       :to="{ name: 'auctionSeller', params: { personId: item.seller_id } }">
											<fa-icon icon="user"
											         fixed-width />
										</b-btn>
										<b-btn variant="outline-primary"
										       v-b-tooltip.hover
										       :title="$t('item.edit')"
										       :to="{ name: 'itemEdit', params: { itemId: item.id } }">
											<fa-icon icon="edit"
											         fixed-width />
										</b-btn>
									</b-button-group>


									<h2>{{ $t('item.auctionOrderNumber') }} <span class="font-weight-bold">{{ item.auction_order_number }}</span></h2>

									<h3><strong>{{ item.seller.code }}-{{ item.number }}</strong> {{ item.title }}</h3>

									<p>
										<span v-if="item.target_price_1">{{ $t('item.targetprice', { number: 1 }) }}: &euro; {{ Math.round(item.target_price_1) }}<br /></span>
										<span v-if="item.target_price_2">{{ $t('item.targetprice', { number: 2 }) }}: &euro; {{ Math.round(item.target_price_2) }}<br /></span>
										<span v-if="item.limit">{{ $t('item.limit') }}: &euro; {{ item.limit }}</span>
									</p>

									<p>
										{{ item.description }}
									</p>
								</div>
							</div>

							<b-alert v-if="formError.errors"
							         show
							         variant="warning">
								<span v-for="(errors, i) in formError.errors" :key="i">
										<span v-for="(error, j) in errors" :key="`${i}-${j}`">{{ error }}<br /></span>
								</span>
							</b-alert>

							<b-form @submit.prevent="submitForm">
								<div class="row">
									<div class="col">
										<h5>{{ $t('bid.price') }}</h5>
										<b-input-group>
											<b-input-group-prepend is-text>&euro;</b-input-group-prepend>
											<b-form-input size="lg"
											              type="number"
											              class="text-right"
											              step="1"
											              v-model="form.price"
														  autocomplete="off"
											              v-focus></b-form-input>
										</b-input-group>
									</div>

									<div class="col">
										<h5>{{ $t('bid.bidNumber') }}</h5>
										<b-form-input size="lg"
										              type="text"
													  autocomplete="off"
										              v-model="form.bid_number"></b-form-input>
									</div>

									<div class="col-2"
									     v-if="item.bid">
										<b-btn variant="outline-danger"
										       v-bind:disabled="isDeleting"
										       @click="showDeleteModal"
										       class="w-100"
										       size="lg"
										       v-b-tooltip.hover
										       :title="$t('bid.delete')">
											<fa-icon icon="trash"
											         fixed-width
											         v-if="!isDeleting" />
											<fa-icon icon="spinner"
											         fixed-width
											         spin
											         v-else />
										</b-btn>
									</div>

									<delete-dialog-modal ref="deleteModal"
									                     :delete-name="$t('bid.deleteBidModal')"
									                     :isDeleting="isDeleting"
									                     @confirm="deleteBid"></delete-dialog-modal>

									<div class="col-2">
										<b-btn variant="primary"
										       v-bind:disabled="isSubmitting"
										       type="submit"
										       class="w-100"
										       size="lg"
										       v-b-tooltip.hover
										       :title="$t('item.sell')">
											<fa-icon icon="gavel"
											         fixed-width
											         v-if="!isSubmitting" />
											<fa-icon icon="spinner"
											         fixed-width
											         spin
											         v-else />
										</b-btn>
									</div>
								</div>
							</b-form>

						</div>

						<b-alert v-if="!item && !isFetching.item"
						         show
						         variant="warning">
							<p class="p-0 m-0">
								{{ $t('item.noItemFoundForAuctionOrderNumber', { AuctionOrderNumber: auctionNumber}) }}
							</p>
						</b-alert>

					</b-jumbotron>
				</div>

				<div class="col-4"
				     v-if="item">
					<b-jumbotron class="p-4 h-100">
						<partial-loader :loading="isFetching.pendingBids"></partial-loader>

						<div v-if="!isFetching.pendingBids && pendingBids">
							<h4>{{ $t('common.pendingBids') }}</h4>

							<p v-if="!pendingBids || pendingBids.length == 0"
							   class="font-italic">
								{{ $t('pendingBid.noData') }}
							</p>

							<table class="table table-striped"
							       v-else>
								<thead>
									<tr>
										<th>{{ $t('bid.bidNumber') }}</th>
										<th class="text-right">{{ $t('pendingBid.price') }}</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(bid, i) in pendingBids" :key="i">
										<td>
											<h3>{{ bid.pending_bid_number }}</h3>
										</td>
										<td class="text-right">&euro; {{ Math.round(bid.price) }}</td>
										<td class="text-right">
											<b-btn variant="primary"
											       v-bind:disabled="isSubmitting"
											       @click="setForm(bid.pending_bid_number, bid.price, true)"
											       size="sm"
											       v-b-tooltip.hover
											       :title="$t('item.usePrice')">
												<fa-icon icon="gavel"
												         fixed-width
												         v-if="!isSubmitting" />
												<fa-icon icon="spinner"
												         fixed-width
												         spin
												         v-else />
											</b-btn>
										</td>
									</tr>
								</tbody>
							</table>

						</div>
					</b-jumbotron>
				</div>
			</div>
		</div>
	</div>

	<div class="col-2 d-none d-lg-block">
		<b-jumbotron class="p-4 h-100"
		             v-if="!isFetching.auction">

			<partial-loader :loading="isFetching.nextItem"></partial-loader>

			<div v-if="!isFetching.nextItem && nextItem">

				<b-btn variant="outline-primary"
				       class="w-100 mb-4"
				       v-bind:disabled="isFetching.item"
				       size="lg"
				       v-if="item.next_auction_order_number"
				       @click="setPage(item.next_auction_order_number)"
				       v-b-tooltip.hover
				       :title="$t('item.nextItem')">
					<fa-icon icon="spinner"
					         fixed-width
					         spin
					         v-if="isFetching.item" />
					<span v-else>{{ $t('item.next') }}</span>
				</b-btn>

				<h5>{{ $t('item.auctionOrderNumber') }} {{ item.next_auction_order_number }}</h5>

				<p>
					<strong>{{ nextItem.seller.code }}-{{ nextItem.number }}</strong> {{ nextItem.title }}
				</p>

				<div v-if="nextItem.media && nextItem.media.length"
				     class="thumbnail"
				     v-bind:style="{ backgroundImage: `url(${nextItem.media[0].url})` }"></div>
			</div>

			<h5 class="text-center"
			    v-if="!isFetching.item && !isFetching.nextItem && nextItem == false">
				{{ $t('item.noNextItem') }}
			</h5>
		</b-jumbotron>

	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service.js';
import PendingBidService from '@/services/pending-bid-service.js';
import ItemService from '@/services/item-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import { flashSuccess, flashWarning } from '@/helpers/flash-message-helper';
import { setTitle } from '@/helpers/page-helper';
import AuctionCategory from '@/components/elements/AutocompleteAuctionCategory';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';

const focus = {
	inserted(el) {
		el.focus()
	},
}
export default {
	directives: { focus },
	components: {
		PartialLoader,
		AuctionCategory,
		DeleteDialogModal
	},
	data() {
		return {
			isFetching: {
				auction: true,
				item: true,
				nextItem: false,
				previousItem: false,
				pendingBids: true
			},
			isDeleting: false,
			isSubmitting: false,
			auction: false,
			item: false,
			nextItem: false,
			previousItem: false,
			itemMeta: false,
			pendingBids: false,
			pendingBidsLimit: 3,
			auctionNumber: false,
			error: false,
			form: {},
			formError: false,
			goToNumber: '',
			isGoingTo: false
		}
	},
	watch: {
		auctionNumber: 'getItem',
		'$route': 'setAuctionOrderNumber'
	},
	methods: {
		initialize() {
			this.setAuctionOrderNumber();
			return this.fetchAuction().then(() => this.getItem());

		},
		setTitle() {
			setTitle(`${this.$t('auction.live')} - ${this.auction.title}`);
		},
		setPage(AuctionNumber) {
			if (AuctionNumber != null) {
				this.$router.push({ query: { auctionNumber: AuctionNumber } });
				this.setTitle();
			}
		},
		setAuctionOrderNumber() {
			const query = this.$route.query;
			if (!isNil(query.auctionNumber))
				this.auctionNumber = query.auctionNumber;
		},
		goTo() {
			this.setPage(this.goToNumber);
			this.goToNumber = '';
		},
		/**
		 * Change category
		 * @param  {object} category Category
		 */
		changeCategory(category) {
			if (!isNil(category) && category.auction_order_number) {
				this.setPage(category.auction_order_number);
			} else {
				flashWarning(this.$t('auction.noAuctionOrderNumberForAuction'));
			}
		},
		getItem() {
			this.isGoingTo = true;
			this.isFetching.pendingBids = true;
			this.isFetching.nextItem = true;
			this.isFetching.previousItem = true;
			this.item = false;
			this.nextItem = false;
			this.previousItem = false;
			this.form = {
				bid_number: '',
				price: ''
			};

			return this.fetchItem().then(() => {
				if (!isNil(this.item.next_auction_order_number)) {
					this.fetchItemByOrderNumber(this.item.next_auction_order_number).then(response => {
						this.isFetching.nextItem = false;
						this.nextItem = response;
					});
				} else {
					this.isFetching.nextItem = false;
				}

				if (!isNil(this.item.previous_auction_order_number)) {
					this.fetchItemByOrderNumber(this.item.previous_auction_order_number).then(response => {
						this.isFetching.previousItem = false;
						this.previousItem = response;
					});
				} else {
					this.isFetching.previousItem = false;
				}

				this.isGoingTo = false;
				this.fetchPendingBids();
			});
		},
		submitForm() {
			this.isSubmitting = true;
			this.error = false;
			this.formError = false;

			if (!isNil(this.item.bid)) {
				return ItemService.updateBid(this.item.id, this.item.bid.id, this.form).then(response => {
					this.isSubmitting = false;
					flashSuccess(this.$t('bid.updateSuccess'), !isNil(this.item.next_auction_order_number));
					if (!isNil(this.item.next_auction_order_number))
						this.setPage(this.item.next_auction_order_number);
				}).catch(error => {
					this.isSubmitting = false;
					this.formError = error.response.data;
				});
			} else {
				return ItemService.createBid(this.item.id, this.form).then(response => {
					this.isSubmitting = false;
					flashSuccess(this.$t('bid.createSuccess'), !isNil(this.item.next_auction_order_number));
					if (!isNil(this.item.next_auction_order_number))
						this.setPage(this.item.next_auction_order_number);
				}).catch(error => {
					this.isSubmitting = false;
					this.formError = error.response.data;
				});
			}
		},
		setForm(bidNumber, price, submit) {
			this.form = {
				bid_number: bidNumber,
				price: Math.round(price),
			}

			if (submit)
				this.submitForm();
		},
		fetchAuction() {
			this.isFetching.auction = true;

			return AuctionService.getOne(this.$route.params.auctionId).then(response => {
				this.isFetching.auction = false;
				this.auction = response;
				this.setTitle();
			}).catch(error => {
				this.isFetching.auction = false;
				this.error = error.message;
			});
		},
		fetchItem() {
			this.isFetching.item = true;

			let params = {
				sort: 'auction_order_number',
				order: 'asc',
				total: 1,
				auction_id: this.auction.id
			};

			if (this.auctionNumber)
				params.auction_order_number = this.auctionNumber;

			return ItemService.getItems(params).then(response => {
				this.isFetching.item = false;
				if (!isNil(response.data) && response.data.length > 0) {
					this.item = response.data[0];
					this.itemMeta = response;
					if (!isNil(this.item.bid)) {
						this.setForm(this.item.bid.bid_number, this.item.bid.price, false);
					}
				}
			}).catch(error => {
				this.isFetching.item = false;
				this.error = error.message;
			});
		},
		fetchItemByOrderNumber(auctionOrderNumber) {

			const params = {
				auction_order_number: auctionOrderNumber,
				auction_id: this.auction.id
			};

			return ItemService.getItems(params).then(response => {
				if (!isNil(response.data) && response.data.length > 0)
					return response.data[0];
			}).catch(error => {
				this.error = error.message;
			});
		},
		fetchPendingBids() {
			this.isFetching.pendingBids = true;
			return PendingBidService.getItemPendingBids(this.item.id, { total: this.pendingBidsLimit }).then(response => {
				this.isFetching.pendingBids = false;
				if (!isNil(response.data))
					this.pendingBids = response.data;
			}).catch(error => {
				this.isFetching.pendingBids = false;
				this.error = error.message;
			});
		},

		showDeleteModal() {
			this.$refs.deleteModal.show();
		},

		deleteBid() {
			this.isDeleting = true;
			this.error = false;

			return ItemService.deleteBid(this.item.id, this.item.bid.id).then(response => {
				flashSuccess(this.$t('bid.deleteSuccess'));
				this.isDeleting = false;
				this.initialize();
			}).catch(error => {
				this.isDeleting = false;
				this.error = error.message;
			});
		},
	},
	mounted() {
		this.initialize().then(() => {
			window.addEventListener('keyup', (event) => {
				if (this.isFetching.item == false && this.isFetching.nextItem == false && this.isFetching.previousItem == false) {
					if (event.keyCode == 39) {
						this.setPage(this.item.next_auction_order_number);
					} else if (event.keyCode == 37) {
						this.setPage(this.item.previous_auction_order_number);
					}
				}
			});
		});
	}
}
</script>

<style lang="scss">
.thumbnail {
    background-size: cover;
    background-position: center;
    height: 250px;
    width: 100%;
}

.gotoform {
    input {
        border-top-right-radius: 0!important;
        border-bottom-right-radius: 0!important;
    }

    button {
        border-top-left-radius: 0!important;
        border-bottom-left-radius: 0!important;
    }
}
</style>



// WEBPACK FOOTER //
// LiveAuction.vue?1b3bf05c